import React from 'react';

interface LoadingOverlayProps {
  isVisible: boolean;
  className?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  className = '',
}) => {
  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[999] flex items-center justify-center bg-black/50 ${className}`}
    >
      <div className="flex flex-col items-center">
        {/* Spinner */}
        <div className="border-t-primary h-12 w-12 animate-spin rounded-full border-4 border-gray-300"></div>
        {/* Optional loading text */}
        <div className="mt-4 text-sm font-medium text-white">Loading...</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
